import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { getBaseHostUrl, IS_EXPORT, toAltTitle } from 'utils'
import styles from './WImage.module.sass'

interface Props {
  next?: boolean // Se utilizzare next o meno, default true
  src?: string
  alt?: string
  title?: string
  className?: string
  maxWidth: number
  maxHeight: number
  blur?: boolean
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
  priority?: false | true
  loading?: 'lazy' | 'eager'
  fallback?: string // object
  editMode?: boolean
  onLoad?: (e: React.ChangeEvent<HTMLImageElement>) => void
  style?: any
}

// TODO: Temporaneo per casi con oggetti che hanno url interno
const getFinalUrl = (url: string | { url: string }, locale) => {
  // se è relativo, aggiungo dominio corrente
  if (typeof url === 'object' && url !== null && 'url' in url) {
    url = url.url
  }

  if (typeof url === 'string' && url.startsWith('/')) {
    return getBaseHostUrl(locale) + url
  }

  return typeof url === 'string' ? url : ''
}

const WImage = (props: Props) => {
  const {
    next = true,
    src = '',
    alt = '',
    title = '',
    maxWidth = 0,
    maxHeight = 0,
    className = '',
    objectFit = undefined,
    blur = false,
    priority = false,
    loading = 'lazy',
    fallback = undefined,
    onLoad = undefined,
    style = undefined,
  } = props
  const router = useRouter()
  const [imgSrc, setImgSrc] = useState(getFinalUrl(src, router.locale))
  const fallbackImage = fallback || `http://placehold.co/${maxWidth}x${maxHeight}/png`


  // dal pagebuilder src può cambiare, va tenuto aggiornato
  useEffect(() => {
    const getPagebuilderExportUrl = async (src: string) => {
      let finalUrl = src
      if (IS_EXPORT && src.includes('/filer/canonical/')) {
        try {
          await fetch(getBaseHostUrl(router.locale) + src).then((response) => {
            if (response.redirected) finalUrl = response.url
          })
        } catch (e) {
          console.error(e)
        }
      }
      return finalUrl
    }

    getPagebuilderExportUrl(src).then((url) => setImgSrc(getFinalUrl(url, router.locale)))
  }, [src])

  return next ? (
    <Image
      src={imgSrc || fallbackImage}
      alt={toAltTitle(alt)}
      title={toAltTitle(title)}
      width={maxWidth}
      height={maxHeight}
      priority={priority}
      loading={loading}
      placeholder={blur ? 'blur' : undefined}
      blurDataURL={blur ? `/_next/image?url=${imgSrc || fallbackImage}&w=32&q=70` : undefined}
      onLoad={onLoad}
      onError={() => {
        setImgSrc(fallbackImage)
      }}
      className={`${styles.root} ${
        objectFit ? styles[`root--objectFit-${objectFit}`] : ''
      } ${className}`}
      style={style}
    />
  ) : (
    <img
      src={imgSrc || fallbackImage}
      alt={toAltTitle(alt)}
      title={toAltTitle(title)}
      className={className}
      style={style}
    />
  )
}

export default WImage
